"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformPrismicDataToTable = void 0;
var richTextSerializer = require("@edwinjoseph/prismic-richtext-markdown");
var transformPrismicDataToTable = function (_a) {
    var name = _a.name, collapsible_sections = _a.collapsible_sections, hide_details = _a.hide_details, slices = _a.slices;
    var tableData = [
        {
            section: {
                title: '',
            },
            rows: [],
        },
    ];
    slices.forEach(function (_a, index) {
        var _b, _c, _d;
        var id = _a.id, slice_type = _a.slice_type, _e = _a.items, items = _e === void 0 ? [] : _e, primary = _a.primary, variation = _a.variation;
        if (slice_type === 'table_section') {
            var sectionData = {
                section: {
                    title: (_b = primary.title) !== null && _b !== void 0 ? _b : '',
                    icon: (_c = primary === null || primary === void 0 ? void 0 : primary.icon) === null || _c === void 0 ? void 0 : _c.url,
                },
                rows: [],
            };
            if (index === 0) {
                tableData = [sectionData];
            }
            else {
                tableData.push(sectionData);
            }
        }
        else {
            var _f = primary.text, text = _f === void 0 ? '' : _f, _g = primary.description, description = _g === void 0 ? '' : _g;
            var formattedRow = {
                default: formatDefaultRow(id, items),
                tableRowButton: formatButtonRow(id, items),
                tableRowWithCta: formatCTARow(id, items),
                tableRowCard: [],
            }[variation];
            tableData[tableData.length - 1].rows.push(__spreadArray([
                variation !== 'tableRowCard'
                    ? {
                        cellId: "".concat(id, "_header"),
                        text: text,
                        description: description,
                        modalContent: renderRichText(primary.modal_info),
                    }
                    : {
                        // if is tableRowCard
                        cellId: "".concat(id, "_header"),
                        type: 'CARD',
                        title: text,
                        description: description,
                        colSpan: primary.columns_to_occupy || 1,
                        icon: (_d = primary === null || primary === void 0 ? void 0 : primary.icon) === null || _d === void 0 ? void 0 : _d.url,
                        href: renderLink(primary.link),
                    }
            ], formattedRow, true));
        }
    });
    return {
        title: name || '',
        collapsibleSections: Boolean(collapsible_sections),
        hideDetails: Boolean(hide_details),
        tableData: tableData,
    };
};
exports.transformPrismicDataToTable = transformPrismicDataToTable;
var renderRichText = function (richText) {
    if (!richText || !richText.length) {
        return undefined;
    }
    return richTextSerializer(richText);
};
var renderLink = function (link) {
    return (link === null || link === void 0 ? void 0 : link.link_type) === 'Web' ? link.url : '';
};
var formatDefaultRow = function (id, items) {
    return items.map(function (_a, rowIndex) {
        var booleanicon = _a.booleanicon, description = _a.description, font_variation = _a.font_variation, hide_progress_bar = _a.hide_progress_bar, modal_info = _a.modal_info, rating = _a.rating, ratingicon = _a.ratingicon, text = _a.text;
        return ({
            cellId: "".concat(id, "_").concat(rowIndex),
            text: text || undefined,
            description: description || undefined,
            modalContent: renderRichText(modal_info),
            checkmarkValue: {
                None: undefined,
                Yes: true,
                No: false,
            }[booleanicon],
            fontVariant: {
                Normal: undefined,
                Price: 'PRICE',
                Underline: 'BIG_WITH_UNDERLINE',
            }[font_variation],
            hideProgressBar: Boolean(hide_progress_bar) || undefined,
            rating: rating && ratingicon
                ? {
                    value: rating,
                    type: {
                        Star: 'star',
                        Zap: 'zap',
                    }[ratingicon],
                }
                : undefined,
        });
    });
};
var formatCTARow = function (id, items) {
    return items.map(function (_a, rowIndex) {
        var button_caption = _a.button_caption, grey_style = _a.grey_style, icon = _a.icon, is_narrow = _a.is_narrow, text = _a.text, description = _a.description, cta_link = _a.cta_link;
        return ({
            cellId: "".concat(id, "_").concat(rowIndex),
            type: 'CTA',
            title: text || undefined,
            price: description || undefined,
            grey: grey_style,
            narrow: is_narrow,
            buttonCaption: button_caption || undefined,
            icon: icon === null || icon === void 0 ? void 0 : icon.url,
            href: renderLink(cta_link),
        });
    });
};
var formatButtonRow = function (id, items) {
    return items.map(function (_a, rowIndex) {
        var text = _a.text, description = _a.description;
        return ({
            cellId: "".concat(id, "_").concat(rowIndex),
            type: 'BUTTON',
            buttonCaption: text || undefined,
            price: description || undefined,
            disabled: true,
        });
    });
};
